<dt-modal-content
  (closeClick)="closeModal(false)"
  [showX]="true"
  [flexContent]="true"
  [contentPadding]="false"
  [size]="quickstart ? 'big' : 'normal'"
>
  <ng-template #title>
    @if (quickstart) {
      <ng-container i18n>Beispiele und Templates laden</ng-container>
    } @else {
      <ng-container i18n>Meine Projekte</ng-container>
    }
  </ng-template>
  <ng-template #content>
    @if (projects) {
      <dt-project-list
        [(projects)]="projects"
        [(projectFolders)]="projectFolders"
        [quickstart]="quickstart"
        [tags]="tags"
        [(filterTagIds)]="filterTagIds"
        [(filterText)]="filterText"
        (loadedProject)="closeModal(true)"
      ></dt-project-list>
    }
  </ng-template>
</dt-modal-content>
